import { render, staticRenderFns } from "./RecommendedProducts.vue?vue&type=template&id=3cc3014e&scoped=true"
import script from "./RecommendedProducts.vue?vue&type=script&lang=js"
export * from "./RecommendedProducts.vue?vue&type=script&lang=js"
import style0 from "./RecommendedProducts.vue?vue&type=style&index=0&id=3cc3014e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3014e",
  null
  
)

export default component.exports